import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import QuotationForm from './pages/QuotationForm';
import AdminBilling from './pages/AdminBilling';
import AdminLogin from './pages/AdminLogin';
import CreateAdmin from './pages/CreateAdmin';
import ProtectedRoute from './components/ProtectedRoute';
import ClientLogin from './pages/ClientLogin';
import ClientRegister from './pages/ClientRegister';
import ClientDashboard from './pages/ClientDashboard';
import ClientProtectedRoute from './components/ClientProtectedRoute';
import SetupAdmin from './pages/SetupAdmin';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './components/NotificationSystem';
// Profile pages
import AboutUs from './pages/profile/AboutUs';
import OurTeam from './pages/profile/OurTeam';
import CompanyProfile from './pages/profile/CompanyProfile';
// Client pages
import OurClients from './pages/clients/OurClients';
import ClientTestimonials from './pages/clients/ClientTestimonials';
import CaseStudies from './pages/clients/CaseStudies';
import './App.css';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <NotificationProvider>
          <Router>
            <Routes>
              {/* Public routes with header and footer */}
              <Route path="/*" element={
                <div className="min-h-screen bg-white">
                  <Header />
                  <main>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/services" element={<Services />} />
                      <Route path="/quotation" element={<QuotationForm />} />
                      {/* Profile routes */}
                      <Route path="/profile/about" element={<AboutUs />} />
                      <Route path="/profile/team" element={<OurTeam />} />
                      <Route path="/profile/company" element={<CompanyProfile />} />
                      {/* Client routes */}
                      <Route path="/clients" element={<OurClients />} />
                      <Route path="/clients/testimonials" element={<ClientTestimonials />} />
                      <Route path="/clients/case-studies" element={<CaseStudies />} />
                    </Routes>
                  </main>
                  <Footer />
                </div>
              } />

              {/* Client routes */}
              <Route path="/client/login" element={<ClientLogin />} />
              <Route path="/client/register" element={<ClientRegister />} />
              <Route path="/client/dashboard" element={
                <ClientProtectedRoute>
                  <ClientDashboard />
                </ClientProtectedRoute>
              } />

              {/* Admin routes - separate layout without header/footer */}
              <Route path="/admin/create" element={<CreateAdmin />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/setup" element={<SetupAdmin />} />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminBilling />
                </ProtectedRoute>
              } />
            </Routes>
          </Router>
        </NotificationProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default App;
